import _extends from "@babel/runtime/helpers/esm/extends"

import * as THREE from "three"
import React from "react"
import { extend, useFrame, useLoader, useThree } from "@react-three/fiber"
import gsap from "gsap"
import { SplatLoader } from "./splat_loader"
import { SplatMaterial } from "./splat_material"

extend({ SplatMaterial })

// https://discourse.threejs.org/t/another-splat-implementation-for-threejs/58883
// https://discourse.threejs.org/t/3d-gaussian-splatting-in-three-js/57858/14
// https://twitter.com/willeastcott/status/1772635449556709826
// https://github.com/playcanvas/engine/pull/6204

function Splat({
  src,
  toneMapped = false,
  alphaTest = 0,
  alphaHash = false,
  // chunkSize = 25000,
  chunkSize = 5,
  active,
  s_id,
  ...props
}) {
  props

  const ref = React.useRef(null)
  const gl = useThree((state) => state.gl)
  const camera = useThree((state) => state.camera)
  const shaderRef = React.useRef<THREE.ShaderMaterial>()
  React.useEffect(() => {
    gsap.to(shaderRef.current.uniforms.uOpacity, {
      ease: "power2.inOut",
      value: active ? 1 : 0.1,
      duration: 0.4,
      onComplete: () => {},
    })
  }, [active])

  // Shared state, globally memoized, the same url re-uses the same daza
  const shared = useLoader(
    SplatLoader,
    src,
    (loader) => {
      loader.gl = gl
      loader.chunkSize = chunkSize
    },
    (e) => {
      "progress"
    },
  )

  const r1 = React.useRef(0)
  const useSlowSort = false

  // Listen to worker results, apply them to the target mesh
  React.useLayoutEffect(() => {
    const cleanup = shared.connect(ref.current)

    const interval = setInterval(() => {
      if (useSlowSort) {
        shared.update(ref.current, camera, alphaHash)
      }
    }, 1000)

    // Cleanup the listener when the component unmounts or src changes
    return () => {
      clearInterval(interval)
      cleanup()
    }
  }, [src])

  // Update the worker
  useFrame(({ pointer }) => {
    if (!useSlowSort) {
      shared.update(ref.current, camera, alphaHash)
    }

    ref.current.material.uniforms.uPointer.value = pointer

    if (r1.current < 1) {
      // console.log("MESH REF::", ref.current)
      r1.current += 1
    }
  })

  // return (
  //    <mesh
  //       ref={ref}
  //       frustumCulled={false}
  //       {...props}>
  //       <splatMaterial

  //          key={`${src}/${alphaTest}/${alphaHash}${SplatMaterial.key}`}
  //          ref={shaderRef}
  //          transparent={!alphaHash}
  //          // depthTest={false}
  //          depthTest={true}
  //          alphaTest={alphaHash ? 0 : alphaTest}
  //          centerAndScaleTexture={shared.centerAndScaleTexture}
  //          covAndColorTexture={shared.covAndColorTexture}
  //          depthWrite={alphaHash ? true : alphaTest > 0}
  //          // depthWrite={false}
  //          blending={alphaHash ? THREE.NormalBlending : THREE.CustomBlending}
  //          blendSrcAlpha={THREE.OneFactor}
  //          alphaHash={!!alphaHash}
  //          toneMapped={toneMapped}
  //       />
  //    </mesh>
  // )
  return /*#__PURE__*/ React.createElement(
    "mesh",
    _extends(
      {
        ref: ref,
        frustumCulled: false,
      },
      props,
    ),
    /*#__PURE__*/ React.createElement("splatMaterial", {
      key: `${src}/${alphaTest}/${alphaHash}${SplatMaterial.key}`,
      //  transparent: !alphaHash,
      ref: shaderRef,
      transparent: !alphaHash,
      depthTest: true,
      alphaTest: alphaHash ? 0 : alphaTest,
      centerAndScaleTexture: shared.centerAndScaleTexture,
      covAndColorTexture: shared.covAndColorTexture,
      depthWrite: alphaHash ? true : alphaTest > 0,
      blending: alphaHash ? THREE.NormalBlending : THREE.CustomBlending,
      blendSrcAlpha: THREE.OneFactor,
      alphaHash: !!alphaHash,
      toneMapped: toneMapped,
    }),
  )
}

export { Splat }
